import { atom, useSetRecoilState } from "recoil";


export interface sessionProps {
    client_name?: string,
    provider_list?: string[],
    use_type?: string,
    banner?: string,
}

export const sessionState = atom<sessionProps>({
    key: "sessionState",
    default: {}
})

export interface optionsProps {
    callback_url?: string;
    token?: string;
    service_code: "AUTH" | "SIGN" | "VCI" | "WITHDRAWAL";
    sign_type?: string;
    sign_content?: string;
    device_type?: "PC" | "TB" | "MO";
    trigger_type?: "PUSH" | "APP_SCHEME";
    default_name?: string;
    default_birthdate?: string;
    default_phone_num?: string;
    default_provider?: string;
    hide_close_button?: boolean;
}

export const optionState = atom<optionsProps>({
    key: "optionState",
    default: {
        service_code: "AUTH"
    }
})

export const trxState = atom({
    key: "trxState",
    default: {
        client_tx_id: "",
        server_tx_id: ""
    }
})

interface alertStateProps {
    title?: string;
    message?: string;
    confirm?: Function;
    cancel?: Function;
}

export const alertState = atom<alertStateProps>({
    key: "alertState",
    default: {}
})

export const alertShowState = atom<boolean>({
    key: "alertShowState",
    default: false
})

export const useAlert = () => {
    const setAlert = useSetRecoilState(alertState);
    const showAlert = useSetRecoilState(alertShowState);

    return (title: string, message?: string, confirm?: Function, cancel?: Function) => {
        showAlert(true);
        setAlert({ title, message, confirm, cancel })
    };
}
